import React, { Component, Fragment } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";


class CopyToClipboardInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copied: false
    };
  }

  render() {
    const { copyValue } = this.props;
    const { copied } = this.state;
    return (
      <CopyToClipboard
        text={ copyValue }
        onCopy={() => {
          this.setState({
            copied: true
          });
        }}
        >
        <div>
          <input type="text" defaultValue={ copyValue } />
          { (copied) ? <p class='small mt-3 py-2'>Copied to clipboard!</p> : <p><a className="share-widget__button"><span>Copy link to clipboard</span></a></p> }
        </div>
      </CopyToClipboard>
    );
  }
}

class CopyToClipboardWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copied: false
    };
  }

  render() {
    const { copyValue, children, copiedHtml } = this.props;
    const { copied } = this.state;
    return (
      <CopyToClipboard
        text={ copyValue }
        onCopy={ () => {
          this.setState({
            copied: true
          });
        }}
      >
        <div>
          { copied ? (copiedHtml) : (children) }
        </div>
      </CopyToClipboard>
    );
  }
}

export { CopyToClipboardInput, CopyToClipboardWrapper };
